var RAResolveComment = {
    init: function (data) {
        this.setVariables();
        this.bindEvents();
        this.setData(data);
        this.initModal();
        this.showResolveCommentForm();
        this.$resolve.off(".resolveCommentModal");
        this.$resolveresults.off(".resolveCommentModal");
    }, setVariables: function () {
        this.$itemsol = $(".portlet-container");
        this.$resolve = $(".resolve-btn");
        this.$resolveresults = this.$itemsol.find(".resolve-btn");
    }, bindEvents: function () {
        this.$resolve.off(".resolveCommentModal");
        this.$resolveresults.off(".resolveCommentModal");
        this.$resolve.on("click.ra.resolveCommentModal", $.proxy(this.showResolveCommentForm, this));
        this.$resolveresults.on("click.ra.resolveCommentModal", $.proxy(this.showResolveCommentForm, this));
    }, showResolveCommentForm: function () {
        var url = Config.contextPath + "/app/portlets/resolve-comment/resolve-comment.jsp";
        var _self = this;

        $.post(url, this.data)
            .done(function (r) {
                _self.$modal.append(r);
                _self.modalLoaded();
                _self.$modal.modal("show");
            });
    }, setData: function (data) {
        this.data = data;
    }, initModal: function () {
        this.$modal = $("#resolveCommentModal");

        if (this.$modal.length === 0) {
            this.$modal = $("<div id='#resolveCommentModal' class='modal fade'></div>");
            this.$modal.css({display: "none"});
            $("body").append(this.$modal);
            this.$modal.on("hidden.bs.modal", $.proxy(this.modalHidden, this));
        }
    }, modalLoaded: function () {
        this.$form = this.$modal.find("form");
        this.$cancelButton = this.$form.find("[data-action=cancel]");
        this.$saveButton = this.$form.find("[data-action=save]");
        this.$answerToQuestion = this.$form.find("#addAnswerToQuestion");
        this.$form.find("input:radio[name=resolutionCategory][value=answerToQuestion]").prop('checked', true);
        this.$form.find(".answerDiv").show();
        this.$form.find('#ResolvingNote').text(Labels.getLabel("Answer to Question is used to answer and resolve comments were essentially a question related to the Solution. The Answer would be added to the question comment as a reply."));
        this.$form.find("input[type=radio]").on("change", $.proxy(this.onChangeResolutionCategory, this));
        this.$cancelButton.on("click", $.proxy(this.cancelClicked, this));
        this.$saveButton.on("click", $.proxy(this.saveClicked, this));
    }, hideModal: function () {
        this.$modal.modal("hide");
    }, modalShown: function () {
        this.$titleText.focus();
    }, modalHidden: function () {
        this.$modal.empty();
    }, onChangeResolutionCategory: function () {
        this.$form.find(".alert").remove();
        let resolutionCategory = this.$form.find('input[name="resolutionCategory"]:checked').val();
        if (resolutionCategory === 'answerToQuestion') {
            this.$form.find(".answerDiv").show();
            this.$form.find('#ResolvingNote').text(Labels.getLabel("Answer to Question is used to answer and resolve comments were essentially a question related to the Solution. The Answer would be added to the question comment as a reply."));
        } else if (resolutionCategory === 'other') {
            this.$form.find(".answerDiv").hide();
            this.$form.find('#ResolvingNote').text(Labels.getLabel("Other is used to resolve comments which did not have any question related to the Solution."));
        }
    }, cancelClicked: function () {
        this.hideModal();
    }, saveClicked: function () {

        let resolutionCategory = this.$form.find('input[name="resolutionCategory"]:checked').val();
        let resolutionAnswer = this.$answerToQuestion.val();
        if (resolutionCategory === 'answerToQuestion' && resolutionAnswer === "") {
            this.showError(Labels.getLabel("No Answer has been entered."), this.$answerToQuestion);
            return false;
        }

        this.$saveButton.attr("disabled", true);
        let loaderContainer = this.$saveButton.closest("form");
        this.showSpinner(loaderContainer);

        let url = Config.contextPath + "/controller/resolveComment/solution/comment/";
        let data = {
            action: "resolveComment",
            solutionID: this.data.solutionID,
            commentID: this.data.commentID,
            isResolved: true,
            resolutionCategory: resolutionCategory,
            resolutionAnswer: resolutionAnswer,
            SToken: Config.csrf.value
        }
        let _self = this;
        $.post(url, data)
            .done(function () {
                _self.$saveButton.removeAttr("disabled");
                _self.hideSpinner(loaderContainer);
                _self.hideModal();
                RA.ViewKB.Comments.load(RA.ViewKB.Comments.currentPage);
            })
            .fail(function () {
                _self.showError(Labels.getLabel("An unexpected error has occurred."));
                _self.$saveButton.removeAttr("disabled");
                _self.hideSpinner(loaderContainer);
            });

    }, showError: function (msg, $element) {
        this.$form.find(".alert").remove();
        let $alert = $("<div class='alert alert-danger'></div>");

        $alert.append("<strong>" + Labels.getLabel("Error") + ": </strong>");
        $alert.append(msg);

        $alert.hide();

        this.$form.prepend($alert);

        $alert.fadeIn();

        if ($element) {
            $element.focus();
        }
    }, showSuccess: function (msg, $element) {
        var $alert = $("<div class='alert alert-success'></div>");

        $alert.append("<strong>" + Labels.getLabel("Success") + ": </strong>");
        $alert.append(msg);

        $alert.hide();

        this.$form.prepend($alert);

        $alert.fadeIn();

        if ($element) {
            $element.focus();
        }
    }, showSpinner: function (elem) {
        var img = $("<img>")
            .attr("src", Config.contextPath + "/app/images/loading.gif")
            .attr("alt", "loading..");

        var loader = $("<div>")
            .attr("class", "loading")
            .append(img);

        if (typeof elem !== "undefined") {
            elem.append(loader);
        }
    }, hideSpinner: function (elem) {
        if (typeof elem !== "undefined") {
            elem.find(".loading").remove();
        }
    }
};